<div mat-dialog-title class="dialog-header-container">
  <button *ngIf="reportSelected !== reportTypes.NONE" matIconButton (click)="selectReportType(reportTypes.NONE)">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <div class="header-content">
    @if (reportSelected === reportTypes.NONE) {
    <h2>Request Report</h2>
    <span class="mat-font-title-md">Select the type of report you would like to order:</span>
    } @else if (reportSelected === reportTypes.PROPERTY) {
    <h2>Request Property Report</h2>
    } @else {
    <h2>Request Damage Assessment</h2>
    }
  </div>
  <button matIconButton class="close-button" (click)="reportDialog.close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  @if (reportSelected === reportTypes.NONE) {
  <div class="report-types">
    <div class="report-type-col">
      <div class="report-type">
        <mat-icon svgIcon="property_report" class="report-type-logo property-logo"></mat-icon>
        <span class="title">Elements Property Report</span>
        <span class="description">Export a PDF with extensive property details run against our Blue Sky imagery</span>
      </div>
      <div class="button-container">
        <button (click)="selectReportType(reportTypes.PROPERTY)" matButton="filled" [disabled]="!reportLoaded">Next</button>
      </div>
    </div>
    <div class="vl"></div>
    <div class="report-type-col">
      <div class="report-type">
        <mat-icon svgIcon="damage_assessment" class="report-type-logo report-logo"></mat-icon>
        <span class="title">Elements Damage Report</span>
        <span class="description">Export a PDF with full property details reported before and after a disaster event to help assess damage</span>
      </div>
      <div class="button-container">
        <button (click)="selectReportType(reportTypes.DAMAGE)" matButton="filled" [disabled]="!reportLoaded || !enableDamageAssessment">Next</button>
      </div>
    </div>
  </div>

  } @else {
  <div class="report-summary">
    <div class="summary-main">
      <div class="summary-top">
        <div class="thumbnail-container">
          <div *ngIf="isLoading" class="image-loading"></div>
          <custom-gallery-image [src]="thumbnail" [class.loading-image]="isLoading" (loadEvent)="isLoading = false"></custom-gallery-image>
        </div>
        <div class="property-info text-label">
          <span><span class="text-title-medium">Property:</span> {{ this.address }}</span>
          <span>Report includes:</span>
          <div *ngIf="reportSelected === reportTypes.DAMAGE" class="report-includes">
            <span><span class="check">✔</span> Gray Sky AI generated attributes: FEMA classification, catastrophe score, structural damage, missing material, tarp coverage</span>
            <span><span class="check">✔</span> Gray Sky Imagery from most recent collection</span>
          </div>
          <span><span class="check">✔</span> Blue Sky AI generated property and parcel attributes</span>
          <span>
            <span class="check">✔</span> 5-way image orientations from the most recent blue sky collection:
            <ul>
              <li>Vertical</li>
              <li>North</li>
              <li>South</li>
              <li>East</li>
              <li>West</li>
            </ul>
          </span>
          <span><span class="check">✔</span> Collected {{ this.formatDate }}</span>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="layer-selection">
        <span class="text-title-medium"><b>Measurement System:</b></span>
        <mat-radio-group class="type-radio-group" [(ngModel)]="unitsImperial" (change)="changeUnits($event)">
          <mat-radio-button [value]="true">Imperial</mat-radio-button>
          <span class="spacer auth-option-spacer"></span>
          <mat-radio-button [value]="false">Metric</mat-radio-button>
        </mat-radio-group>
        <span class="text-title-medium"><b>Select any additional data you would like to include in your report:</b></span>
        <div class="scroll">
          <div class="sky-column">
            <div class="blue-sky">
              <div class="layer-title">
                <span class="mat-font-title-md">Additional Blue Sky Imagery</span>
                <span class="mat-font-label-md mat-text-primary"> (Optional)</span>
              </div>
              <span class="layer-description">Select additional collection years to include:</span>
              <div class="layer-checkboxes">
                <ng-container *ngFor="let layer of projects.urban">
                  <div *ngIf="!layer.fixed">
                    <mat-checkbox (change)="layer.selected = !layer.selected">{{ layer.report_name }}</mat-checkbox>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="blue-sky" *ngIf="projects.graysky.length > 0">
              <div class="layer-title">
                <span class="mat-font-title-md">Additional Gray Sky Imagery</span>
                <span class="mat-font-label-md mat-text-primary"> (Optional)</span>
              </div>
              <span class="layer-description">Select Gray Sky Imagery to include in your report:</span>
              <div class="layer-checkboxes">
                <ng-container *ngFor="let layer of projects.graysky">
                  <div *ngIf="!layer.fixed">
                    <mat-checkbox (change)="layer.selected = !layer.selected">{{ layer.report_name }}</mat-checkbox>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="color-infrared" *ngIf="projects.ir.length > 0">
            <div class="layer-title">
              <span class="mat-font-title-md">Most Recent Color Infrared Imagery</span>
              <span class="mat-font-label-md mat-text-primary"> (Optional)</span>
            </div>
            <span class="layer-description">Use this capability to build a better fire risk analysis:</span>
            <div class="layer-checkboxes">
              <ng-container *ngFor="let layer of projects.ir">
                <div *ngIf="!layer.fixed">
                  <mat-checkbox (change)="layer.selected = !layer.selected">{{ layer.report_name }}</mat-checkbox>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
    <mat-card class="download-card">
      <mat-card-content>
        <span class="text-title-medium">Report Summary:</span>
        <span>{{ reportSelected === reportTypes.PROPERTY ? "Property Report" : "Damage Assessment" }}</span>
        <div>
          <ng-container *ngIf="(fixedProjects() | async).length > 0">
            <div *ngFor="let layer of fixedProjects() | async">
              <span>+ {{ layer.report_name }}</span>
            </div>
          </ng-container>
          <ng-container *ngIf="(selectedProjects() | async).length > 0">
            <div *ngFor="let layer of selectedProjects() | async">
              <span>+ {{ layer.report_name }}</span>
            </div>
          </ng-container>
        </div>
        <mat-divider></mat-divider>
      </mat-card-content>
      <mat-card-footer>
        <button matButton="filled" (click)="downloadReport()">Download Report</button>
      </mat-card-footer>
    </mat-card>
  </div>
  }
</mat-dialog-content>
